/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '@angular/material/progress-spinner/progress-spinner';
import * as import2 from '@angular/material/core/compatibility/compatibility';
import * as import4 from '@angular/core/src/change_detection/change_detection_util';
import * as import5 from '@angular/core/src/linker/view';
import * as import6 from '@angular/core/src/linker/view_utils';
import * as import8 from '@angular/core/src/metadata/view';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '@angular/core/src/zone/ng_zone';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from './progress-spinner.css.shim.ngstyle';
var MdProgressSpinnerModuleInjector = (function (_super) {
    __extends(MdProgressSpinnerModuleInjector, _super);
    function MdProgressSpinnerModuleInjector(parent) {
        return _super.call(this, parent, [], []) || this;
    }
    MdProgressSpinnerModuleInjector.prototype.createInternal = function () {
        this._CompatibilityModule_0 = new import2.CompatibilityModule();
        this._MdProgressSpinnerModule_1 = new import1.MdProgressSpinnerModule();
        return this._MdProgressSpinnerModule_1;
    };
    MdProgressSpinnerModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === import2.CompatibilityModule)) {
            return this._CompatibilityModule_0;
        }
        if ((token === import1.MdProgressSpinnerModule)) {
            return this._MdProgressSpinnerModule_1;
        }
        return notFoundResult;
    };
    MdProgressSpinnerModuleInjector.prototype.destroyInternal = function () {
    };
    return MdProgressSpinnerModuleInjector;
}(import0.NgModuleInjector));
export var MdProgressSpinnerModuleNgFactory = new import0.NgModuleFactory(MdProgressSpinnerModuleInjector, import1.MdProgressSpinnerModule);
var Wrapper_MdProgressSpinner = (function () {
    function Wrapper_MdProgressSpinner(p0, p1, p2) {
        this._changed = false;
        this.context = new import1.MdProgressSpinner(p0, p1, p2);
        this._expr_0 = import4.UNINITIALIZED;
        this._expr_1 = import4.UNINITIALIZED;
        this._expr_2 = import4.UNINITIALIZED;
        this._expr_3 = import4.UNINITIALIZED;
        this._expr_4 = import4.UNINITIALIZED;
        this._expr_5 = import4.UNINITIALIZED;
        this._expr_6 = import4.UNINITIALIZED;
    }
    Wrapper_MdProgressSpinner.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdProgressSpinner.prototype.ngOnDestroy = function () {
        this.context.ngOnDestroy();
    };
    Wrapper_MdProgressSpinner.prototype.check_color = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.color = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdProgressSpinner.prototype.check_value = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.value = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdProgressSpinner.prototype.check_mode = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.mode = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdProgressSpinner.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdProgressSpinner.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_3 = this.context._ariaValueMin;
        if (import6.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementAttribute(el, 'aria-valuemin', ((currVal_3 == null) ? null : currVal_3.toString()));
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context._ariaValueMax;
        if (import6.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementAttribute(el, 'aria-valuemax', ((currVal_4 == null) ? null : currVal_4.toString()));
            this._expr_4 = currVal_4;
        }
        var currVal_5 = this.context.value;
        if (import6.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementAttribute(el, 'aria-valuenow', ((currVal_5 == null) ? null : currVal_5.toString()));
            this._expr_5 = currVal_5;
        }
        var currVal_6 = this.context.mode;
        if (import6.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            view.renderer.setElementAttribute(el, 'mode', ((currVal_6 == null) ? null : currVal_6.toString()));
            this._expr_6 = currVal_6;
        }
    };
    Wrapper_MdProgressSpinner.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdProgressSpinner.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdProgressSpinner;
}());
export { Wrapper_MdProgressSpinner };
var Wrapper_MdSpinner = (function () {
    function Wrapper_MdSpinner(p0, p1, p2) {
        this._changed = false;
        this.context = new import1.MdSpinner(p0, p1, p2);
        this._expr_0 = import4.UNINITIALIZED;
        this._expr_1 = import4.UNINITIALIZED;
        this._expr_2 = import4.UNINITIALIZED;
        this._expr_3 = import4.UNINITIALIZED;
        this._expr_4 = import4.UNINITIALIZED;
        this._expr_5 = import4.UNINITIALIZED;
    }
    Wrapper_MdSpinner.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdSpinner.prototype.ngOnDestroy = function () {
        this.context.ngOnDestroy();
    };
    Wrapper_MdSpinner.prototype.check_color = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.color = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdSpinner.prototype.check_value = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.value = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdSpinner.prototype.check_mode = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import6.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.mode = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdSpinner.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdSpinner.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_3 = true;
        if (import6.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementClass(el, 'mat-spinner', currVal_3);
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context.value;
        if (import6.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementAttribute(el, 'aria-valuenow', ((currVal_4 == null) ? null : currVal_4.toString()));
            this._expr_4 = currVal_4;
        }
        var currVal_5 = this.context.mode;
        if (import6.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementAttribute(el, 'mode', ((currVal_5 == null) ? null : currVal_5.toString()));
            this._expr_5 = currVal_5;
        }
    };
    Wrapper_MdSpinner.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdSpinner.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdSpinner;
}());
export { Wrapper_MdSpinner };
var Wrapper_MdProgressSpinnerCssMatStyler = (function () {
    function Wrapper_MdProgressSpinnerCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdProgressSpinnerCssMatStyler();
        this._expr_0 = import4.UNINITIALIZED;
    }
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import6.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-progress-spinner', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdProgressSpinnerCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdProgressSpinnerCssMatStyler;
}());
export { Wrapper_MdProgressSpinnerCssMatStyler };
var Wrapper_MdProgressCircleCssMatStyler = (function () {
    function Wrapper_MdProgressCircleCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdProgressCircleCssMatStyler();
        this._expr_0 = import4.UNINITIALIZED;
    }
    Wrapper_MdProgressCircleCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdProgressCircleCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdProgressCircleCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdProgressCircleCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import6.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-progress-circle', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdProgressCircleCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdProgressCircleCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdProgressCircleCssMatStyler;
}());
export { Wrapper_MdProgressCircleCssMatStyler };
var renderType_MdProgressSpinner_Host = import6.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {});
var View_MdProgressSpinner_Host0 = (function (_super) {
    __extends(View_MdProgressSpinner_Host0, _super);
    function View_MdProgressSpinner_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdProgressSpinner_Host0, renderType_MdProgressSpinner_Host, import9.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import10.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdProgressSpinner_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.selectOrCreateRenderHostElement(this.renderer, 'md-progress-spinner', new import6.InlineArray2(2, 'role', 'progressbar'), rootSelector, null);
        this.compView_0 = new View_MdProgressSpinner0(this.viewUtils, this, 0, this._el_0);
        this._MdProgressSpinner_0_3 = new Wrapper_MdProgressSpinner(this.injectorGet(import12.NgZone, this.parentIndex), new import13.ElementRef(this._el_0), this.renderer);
        this.compView_0.create(this._MdProgressSpinner_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import11.ComponentRef_(0, this, this._el_0, this._MdProgressSpinner_0_3.context);
    };
    View_MdProgressSpinner_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import1.MdProgressSpinner) && (0 === requestNodeIndex))) {
            return this._MdProgressSpinner_0_3.context;
        }
        return notFoundResult;
    };
    View_MdProgressSpinner_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        if (this._MdProgressSpinner_0_3.ngDoCheck(this, this._el_0, throwOnChange)) {
            this.compView_0.markAsCheckOnce();
        }
        this._MdProgressSpinner_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_MdProgressSpinner_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
        this._MdProgressSpinner_0_3.ngOnDestroy();
    };
    View_MdProgressSpinner_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdProgressSpinner_Host0;
}(import5.AppView));
export var MdProgressSpinnerNgFactory = new import11.ComponentFactory('md-progress-spinner, mat-progress-spinner, md-progress-circle, mat-progress-circle', View_MdProgressSpinner_Host0, import1.MdProgressSpinner);
var styles_MdProgressSpinner = [import14.styles];
var renderType_MdProgressSpinner = import6.createRenderComponentType('', 0, import8.ViewEncapsulation.Emulated, styles_MdProgressSpinner, {});
var View_MdProgressSpinner0 = (function (_super) {
    __extends(View_MdProgressSpinner0, _super);
    function View_MdProgressSpinner0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdProgressSpinner0, renderType_MdProgressSpinner, import9.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import10.ChangeDetectorStatus.CheckOnce) || this;
    }
    View_MdProgressSpinner0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import6.createRenderElement(this.renderer, parentRenderNode, ':svg:svg', new import6.InlineArray4(4, 'preserveAspectRatio', 'xMidYMid meet', 'viewBox', '0 0 100 100'), null);
        this._el_1 = import6.createRenderElement(this.renderer, this._el_0, ':svg:path', import6.EMPTY_INLINE_ARRAY, null);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._el_1
        ]), null);
        return null;
    };
    return View_MdProgressSpinner0;
}(import5.AppView));
export { View_MdProgressSpinner0 };
var renderType_MdSpinner_Host = import6.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {});
var View_MdSpinner_Host0 = (function (_super) {
    __extends(View_MdSpinner_Host0, _super);
    function View_MdSpinner_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdSpinner_Host0, renderType_MdSpinner_Host, import9.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import10.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdSpinner_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.selectOrCreateRenderHostElement(this.renderer, 'md-spinner', new import6.InlineArray4(4, 'mode', 'indeterminate', 'role', 'progressbar'), rootSelector, null);
        this.compView_0 = new View_MdSpinner0(this.viewUtils, this, 0, this._el_0);
        this._MdSpinner_0_3 = new Wrapper_MdSpinner(new import13.ElementRef(this._el_0), this.injectorGet(import12.NgZone, this.parentIndex), this.renderer);
        this.compView_0.create(this._MdSpinner_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import11.ComponentRef_(0, this, this._el_0, this._MdSpinner_0_3.context);
    };
    View_MdSpinner_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import1.MdSpinner) && (0 === requestNodeIndex))) {
            return this._MdSpinner_0_3.context;
        }
        return notFoundResult;
    };
    View_MdSpinner_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._MdSpinner_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this._MdSpinner_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_MdSpinner_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
        this._MdSpinner_0_3.ngOnDestroy();
    };
    View_MdSpinner_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdSpinner_Host0;
}(import5.AppView));
export var MdSpinnerNgFactory = new import11.ComponentFactory('md-spinner, mat-spinner', View_MdSpinner_Host0, import1.MdSpinner);
var styles_MdSpinner = [import14.styles];
var renderType_MdSpinner = import6.createRenderComponentType('', 0, import8.ViewEncapsulation.Emulated, styles_MdSpinner, {});
var View_MdSpinner0 = (function (_super) {
    __extends(View_MdSpinner0, _super);
    function View_MdSpinner0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdSpinner0, renderType_MdSpinner, import9.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import10.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdSpinner0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import6.createRenderElement(this.renderer, parentRenderNode, ':svg:svg', new import6.InlineArray4(4, 'preserveAspectRatio', 'xMidYMid meet', 'viewBox', '0 0 100 100'), null);
        this._el_1 = import6.createRenderElement(this.renderer, this._el_0, ':svg:path', import6.EMPTY_INLINE_ARRAY, null);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._el_1
        ]), null);
        return null;
    };
    return View_MdSpinner0;
}(import5.AppView));
export { View_MdSpinner0 };
//# sourceMappingURL=progress-spinner.ngfactory.js.map